export const getLocal = (key: string) => {
  return window.localStorage ? window.localStorage.getItem(key) : null;
};

export const setLocal = (key: string, value: any, callback?: () => void) => {
  try {
    window.localStorage?.setItem(key, value);
  } catch (e) {
    callback?.();
  }
};

export const length = () => {
  return window.localStorage?.length;
};

export const clearLocal = () => {
  return window.localStorage ? window.localStorage.clear() : null;
};

export const removeLocal = (key: string) => {
  window.localStorage?.removeItem(key);
};

export const getSession = (key: string) => {
  return window.sessionStorage ? window.sessionStorage.getItem(key) : null;
};

export const setSession = (key: string, value: any, callback?: () => void) => {
  try {
    window.sessionStorage?.setItem(key, value);
  } catch (e) {
    callback?.();
  }
};

export const removeSession = (key: string) => {
  window.sessionStorage?.removeItem(key);
};

export default {
  getLocal,
  setLocal,
  length,
  clearLocal,
  removeLocal,
  getSession,
  setSession,
  removeSession,
};
